import buildUrl from 'cloudinary-build-url';
import { Container, Row, Col } from 'react-bootstrap';
import { Styles } from './styles';

export type BreadcrumbProps = {
  image: string;
  title: string;
};

const BreadcrumbComponent: React.FC<BreadcrumbProps> = ({ image, title }) => {
  const imageUrl = buildUrl(image, {
    cloud: {
      cloudName: 'appmasters-io',
    },
    transformations: {
      resize: {
        type: 'fit',
        quality: 20,
      },
    },
  });
  return (
    <Styles>
      <section className="breadcrumb-area" style={{ backgroundImage: `url(${imageUrl})` }}>
        <Container>
          <Row>
            <Col md="12" className="text-center">
              <div className="breadcrumb-box">
                <h1 className="breadcrumb-title">{title}</h1>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Styles>
  );
};

export default BreadcrumbComponent;
